/* istanbul ignore file */
import React from 'react';
import ReactDOM from 'react-dom';
import OneClick from './views/OneClick';
var init = function init(container, props) {
  ReactDOM.render( /*#__PURE__*/React.createElement(OneClick, props), container);
};
var unmount = function unmount(container) {
  return ReactDOM.unmountComponentAtNode(container);
};
export default OneClick;
export * from './views/OneClick/interfaces';
export * from './modules/DropInPayments/constants';
export { OneClick, init, unmount };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/index.js
// module id = 2884
// module chunks = 11